import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faHtml5,
  faCss3Alt,
  faJs,
  faPython,
  faGitAlt,
  faGithub,
  faReact,
  faBootstrap,
  faLinkedin,
  faNodeJs,
} from "@fortawesome/free-brands-svg-icons";

import {
  faDatabase,
  faEnvelope,
  faMoon,
  faSun,
  faLongArrowAltLeft,
  faLongArrowAltRight,
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faHtml5,
  faCss3Alt,
  faJs,
  faPython,
  faGitAlt,
  faGithub,
  faReact,
  faBootstrap,
  faLinkedin,
  faNodeJs,
  faEnvelope,
  faMoon,
  faSun,
  faLongArrowAltLeft,
  faLongArrowAltRight,
  faDatabase
);

export default library;
